import { useMemo } from 'react';
import { CheckoutContext, useCheckoutContext } from '../CheckoutContext';

const getEducatorLink = (checkoutContext: CheckoutContext): string => {
    if (
        checkoutContext.checkoutState.origin === 'embed' ||
        checkoutContext.checkoutState.origin === 'landing_page'
    ) {
        return `https://${checkoutContext.educator.slug}.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`;
    }

    return `${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/${checkoutContext.educator.slug}`;
};

export const useCheckoutEducatorLink = (): string => {
    const checkoutContext = useCheckoutContext();

    return useMemo(() => {
        return getEducatorLink(checkoutContext);
    }, [checkoutContext]);
};
